import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, DoCheck, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmpleadosModalComponent } from 'src/app/pages/empleados/components/mantenimiento/empleados-modal/empleados-modal.component';
import { EmpleadosPageComponent } from 'src/app/pages/empleados/components/mantenimiento/empleados-page/empleados-page.component';
import { EmpleadoCrud } from 'src/app/pages/empleados/models/empleado';
import { EmpresasModel } from 'src/app/pages/configuracion/maestros/empresas/models/empresas-model';
import { RecuperaEmpresasApiService } from 'src/app/pages/configuracion/maestros/empresas/services/recupera-empresas-api.service';
import { TipoMail } from 'src/app/pages/configuracion/Envios/envios/models/tipo-mail';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { FirmanteEnvioSimple } from '../../models/firmante-envio-simple';
import { EnvioSimpleBusquedaEmpleadosCacheService } from '../../services/envio-simple-busqueda-empleados-cache.service';
import { EnvioSimpleFlowService } from '../../services/envio-simple-flow.service';
import {
  ORDEN_CONTACTO_PERSONAL,
  filtrarOpcionesOrigenContacto
} from '../../utils/contacto-origen.util';

@Component({
  selector: 'app-envio-simple-firmantes-list',
  templateUrl: './envio-simple-firmantes-list.component.html',
  styleUrls: ['./envio-simple-firmantes-list.component.css']
})
export class EnvioSimpleFirmantesListComponent implements DoCheck {
  @Input() canalCorreoActivo = true;
  @Input() canalSMSActivo = false;
  /** Paridad dosier: si false, checkbox SMS desactivado + tooltip. */
  @Input() moduloSmsActivo = false;
  @Input() mostrarAvisoCanales = false;
  @Input() forzarValidacionContacto = false;
  @Input() codigosEmailDuplicado: string[] = [];
  @Input() codigosTelefonoDuplicado: string[] = [];
  @Input() set tiposMails(value: TipoMail[] | null) {
    this.opcionesOrigenContacto = filtrarOpcionesOrigenContacto(value);
    this.sincronizarListasOrigen();
  }
  @Output() canalCorreoChange = new EventEmitter<boolean>();
  @Output() canalSMSChange = new EventEmitter<boolean>();
  @Output() ordenMailChange = new EventEmitter<string>();
  @Output() ordenTelefonoSMSChange = new EventEmitter<string>();
  @Output() limpiarMarcasEmailDuplicado = new EventEmitter<void>();
  @Output() limpiarMarcasTelefonoDuplicado = new EventEmitter<void>();

  opcionesOrigenContacto: TipoMail[] = filtrarOpcionesOrigenContacto([]);
  listaOrigenMail: DesplegableData[] = [];
  listaOrigenTelefono: DesplegableData[] = [];

  private ultimoOrdenMailSincronizado = '';
  private ultimoOrdenTelefonoSincronizado = '';
  private ultimaOpcionesRef: TipoMail[] | null = null;

  constructor(
    public envioSimpleFlowService: EnvioSimpleFlowService,
    private dialog: MatDialog,
    private datosEmpresasApiService: RecuperaEmpresasApiService,
    private busquedaEmpleadosCache: EnvioSimpleBusquedaEmpleadosCacheService
  ) {}

  ngDoCheck(): void {
    this.sincronizarListasOrigen();
  }

  get firmantes(): FirmanteEnvioSimple[] {
    return this.envioSimpleFlowService.firmantesEnvioList;
  }

  /** Igual que el dosier regular: en paralelo no se muestra el número de orden. */
  get ocultarOrden(): boolean {
    return !!this.envioSimpleFlowService.ajustesEnvioEnvio.envioParalelo;
  }

  get mostrarEmail(): boolean {
    return this.canalCorreoActivo;
  }

  get mostrarTelefono(): boolean {
    return this.moduloSmsActivo && this.canalSMSActivo;
  }

  get ordenMail(): string {
    return this.envioSimpleFlowService.canalesEnvio.ordenMail || ORDEN_CONTACTO_PERSONAL;
  }

  get ordenTelefonoSMS(): string {
    return this.envioSimpleFlowService.canalesEnvio.ordenTelefonoSMS || ORDEN_CONTACTO_PERSONAL;
  }

  get firmantesFirmaCount(): number {
    return this.firmantes.filter(firmante => !firmante.esValidador).length;
  }

  get puedeAnadirValidador(): boolean {
    return !this.firmantes.some(firmante => firmante.esValidador);
  }

  puedeEliminar(firmante: FirmanteEnvioSimple): boolean {
    if (firmante.esPrincipal) {
      return false;
    }
    if (firmante.esValidador) {
      return true;
    }
    return this.firmantesFirmaCount > 1;
  }

  drop(event: CdkDragDrop<FirmanteEnvioSimple[]>): void {
    this.envioSimpleFlowService.reordenarFirmantesEnvio(event.previousIndex, event.currentIndex);
  }

  onDatosChange(
    codigo: string,
    datos: Partial<Pick<FirmanteEnvioSimple, 'nombre' | 'apellido1' | 'apellido2' | 'email' | 'telefono'>>
  ): void {
    this.envioSimpleFlowService.actualizarDatosFirmanteEnvio(codigo, datos);
    if (datos.email !== undefined && this.codigosEmailDuplicado.includes(codigo)) {
      this.limpiarMarcasEmailDuplicado.emit();
    }
    if (datos.telefono !== undefined && this.codigosTelefonoDuplicado.includes(codigo)) {
      this.limpiarMarcasTelefonoDuplicado.emit();
    }
  }

  onBuscarEmpleado(firmante: FirmanteEnvioSimple): void {
    const restaurarBusqueda = !!firmante.codigoEmpleado;
    const dialogRef = this.dialog.open(EmpleadosPageComponent, {
      data: {
        modoSeleccionFirmante: true,
        codigoFirmante: firmante.codigo,
        codigoEmpleadoPreseleccionado: firmante.codigoEmpleado,
        empleadoPreseleccionado: firmante.datosEmpleado,
        restaurarBusqueda
      },
      panelClass: 'modal-empleados-seleccion-firmante',
      width: 'min(1200px, 94vw)',
      height: '85vh',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      const empleado = result?.empleado as EmpleadoCrud | undefined;
      if (empleado) {
        this.envioSimpleFlowService.aplicarEmpleadoAFirmanteEnvio(firmante.codigo, empleado);
      }
    });
  }

  onEditarOtrosDatos(firmante: FirmanteEnvioSimple): void {
    this.obtenerEmpresasParaModal(empresas => {
      const esAltaSinEmpleadoMaestro = !firmante.codigoEmpleado;
      const empleado = this.envioSimpleFlowService.construirEmpleadoDesdeFirmanteEnvio(firmante);
      const snapshot = this.busquedaEmpleadosCache.obtenerSnapshot();

      const dialogRef = this.dialog.open(EmpleadosModalComponent, {
        data: {
          empleado,
          nuevo: esAltaSinEmpleadoMaestro,
          codigoEmpleado: firmante.codigoEmpleado,
          empresas,
          empresasList: snapshot?.empresasListModal ?? [],
          modoEnvioSimple: true,
          esPrincipalFirmante: firmante.esPrincipal
        },
        panelClass: 'modal-class-detalle',
        position: { right: '0' }
      });

      dialogRef.afterClosed().subscribe(result => {
        const empleadoActualizado = result?.empleado as EmpleadoCrud | undefined;
        if (empleadoActualizado) {
          this.envioSimpleFlowService.aplicarEmpleadoAFirmanteEnvio(firmante.codigo, empleadoActualizado);
          const firmanteActualizado =
            this.envioSimpleFlowService.firmantesEnvioList.find(item => item.codigo === firmante.codigo);
          const empleadoParaCache = (firmanteActualizado?.datosEmpleado ?? empleadoActualizado) as EmpleadoCrud;
          if (result?.persistidoEnMaestro) {
            this.busquedaEmpleadosCache.invalidarEmpleados();
          }
          // Alta o edicion: dejar al empleado en cache seleccionado para la proxima lupa
          this.busquedaEmpleadosCache.asegurarEmpleadoSeleccionadoEnFirmante(
            firmante.codigo,
            empleadoParaCache
          );
        }
      });
    });
  }

  onEliminar(firmante: FirmanteEnvioSimple): void {
    if (!this.puedeEliminar(firmante)) {
      return;
    }
    this.confirmarEliminarFirmante(firmante);
  }

  onAnadirValidador(): void {
    if (!this.puedeAnadirValidador) {
      this.dialog.open(ModalMessageComponent, {
        data: {
          mensaje: 'Solo se puede añadir un validador.',
          alert: true
        }
      });
      return;
    }
    this.envioSimpleFlowService.agregarValidadorEnvio();
  }

  onToggleCanalCorreo(checked: boolean): void {
    this.canalCorreoChange.emit(checked);
  }

  onToggleCanalSMS(checked: boolean): void {
    if (!this.moduloSmsActivo) {
      this.canalSMSChange.emit(false);
      return;
    }
    this.canalSMSChange.emit(checked);
  }

  onOrdenMailChange(codigo: string): void {
    if (!codigo || codigo === this.ordenMail) {
      return;
    }
    this.ordenMailChange.emit(codigo);
  }

  onOrdenTelefonoChange(codigo: string): void {
    if (!codigo || codigo === this.ordenTelefonoSMS) {
      return;
    }
    this.ordenTelefonoSMSChange.emit(codigo);
  }

  onOrdenMailSeleccionado(item: DesplegableData | null): void {
    if (!item?.id) {
      return;
    }
    this.onOrdenMailChange(item.id);
  }

  onOrdenTelefonoSeleccionado(item: DesplegableData | null): void {
    if (!item?.id) {
      return;
    }
    this.onOrdenTelefonoChange(item.id);
  }

  trackByCodigo(_index: number, firmante: FirmanteEnvioSimple): string {
    return firmante.codigo;
  }

  private mapearListaOrigenContacto(codigoSeleccionado: string): DesplegableData[] {
    return this.opcionesOrigenContacto.map(opcion => ({
      id: opcion.codigo,
      desc: opcion.desc,
      seleccionado: opcion.codigo === codigoSeleccionado
    }));
  }

  private sincronizarListasOrigen(): void {
    const ordenMail = this.ordenMail;
    const ordenTelefono = this.ordenTelefonoSMS;
    if (
      ordenMail === this.ultimoOrdenMailSincronizado &&
      ordenTelefono === this.ultimoOrdenTelefonoSincronizado &&
      this.opcionesOrigenContacto === this.ultimaOpcionesRef
    ) {
      return;
    }
    this.ultimoOrdenMailSincronizado = ordenMail;
    this.ultimoOrdenTelefonoSincronizado = ordenTelefono;
    this.ultimaOpcionesRef = this.opcionesOrigenContacto;
    this.listaOrigenMail = this.mapearListaOrigenContacto(ordenMail);
    this.listaOrigenTelefono = this.mapearListaOrigenContacto(ordenTelefono);
  }

  private obtenerEmpresasParaModal(callback: (empresas: EmpresasModel[]) => void): void {
    const snapshot = this.busquedaEmpleadosCache.obtenerSnapshot();
    if (snapshot?.empresas.length) {
      callback(snapshot.empresas);
      return;
    }
    this.datosEmpresasApiService.getEmpresas([], 0).subscribe({
      next: empresas => callback(empresas),
      error: () => callback([])
    });
  }

  private confirmarEliminarFirmante(firmante: FirmanteEnvioSimple): void {
    const codigo = firmante.codigo;
    const esValidador = firmante.esValidador;
    const etiqueta = firmante.desc ?? 'firmante';
    let titulo = '¿Quitar firmante?';
    let mensaje =
      `¿Desea eliminar el ${etiqueta} del envío completo? Se quitará de todos los documentos junto con su configuración.`;
    let textoConfirmacion = 'Quitar firmante';

    if (esValidador) {
      titulo = '¿Eliminar validador?';
      mensaje = '¿Está seguro que desea eliminar el validador del envío?';
      textoConfirmacion = 'Quitar valiador';
    } else {
      const docsConConfig = this.envioSimpleFlowService.obtenerDocumentosConConfiguracionFirmante(codigo);
      if (docsConConfig.length > 0) {
        mensaje += ` Tiene configuración en: ${docsConConfig.map(doc => doc.nombre).join(', ')}.`;
      }
    }

    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      data: {
        tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
        icono: 'icon-delete',
        titulo,
        mensaje,
        textoConfirmacion,
        iconoConfirmacion: 'icon-delete',
        textoCancelar: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        this.envioSimpleFlowService.eliminarFirmanteGlobal(codigo);
      }
    });
  }
}
